import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESHISTORY,
  DELETE_SALESHISTORY,
  UPDATE_SALESHISTORY,
  ADD_NEW_SALESHISTORY,
} from "./actionType";

import {
  getSalesHistorySuccess,
  getSalesHistoryFail,
  deleteSalesHistorySuccess,
  deleteSalesHistoryFail,
  updateSalesHistorySuccess,
  updateSalesHistoryFail,
  addSalesHistorySuccess,
  addSalesHistoryFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesHistoryApi,
  getSalesHistoryApi,
  updateSalesHistoryApi,
  deleteSalesHistoryApi,
  addNewSalesHistoryApi
} from "../../helpers/backend_helper";

function* getSalesHistory({ payload: salesHistory }) {
  try {
    const response = yield call(getSalesHistoryApi, salesHistory);
    yield put(getSalesHistorySuccess(GET_SALESHISTORY, response.data));
  } catch (error) {
    yield put(getSalesHistoryFail(GET_SALESHISTORY, error));
  }
}

function* onUpdateSalesHistory({ payload: salesHistory }) {
  try {
    if (salesHistory.setApprove) {
      const response = yield call(approveSalesHistoryApi, salesHistory);
      yield put(updateSalesHistorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesHistoryApi, salesHistory);
      yield put(updateSalesHistorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesHistory({ payload: salesHistory }) {
  try {
    const response = yield call(deleteSalesHistoryApi, salesHistory);
    yield put(deleteSalesHistorySuccess({ salesHistory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesHistory({ payload: salesHistory }) {
  try {
    const response = yield call(addNewSalesHistoryApi, salesHistory);
    yield put(addSalesHistorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesHistory() {
  yield takeEvery(GET_SALESHISTORY, getSalesHistory);
}

export function* watchUpdateSalesHistory() {
  yield takeEvery(UPDATE_SALESHISTORY, onUpdateSalesHistory);
}

export function* watchDeleteSalesHistory() {
  yield takeEvery(DELETE_SALESHISTORY, onDeleteSalesHistory);
}

export function* watchAddNewSalesHistory() {
  yield takeEvery(ADD_NEW_SALESHISTORY, onAddNewSalesHistory);
}

function* salesHistorySaga() {
  yield all([
    fork(watchGetSalesHistory),
    fork(watchDeleteSalesHistory),
    fork(watchUpdateSalesHistory),
    fork(watchAddNewSalesHistory)
  ]);
}

export default salesHistorySaga;
